import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Card, Row, Col} from 'antd';

import * as mapActions from '../actions/map-actions';
import MapboxLight from '../charts/Mapbox';
import StateMap from "../charts/StateMap";
import CardMenu from './CardMenu.js';

import './CountyCard.css';

class CountyCard extends Component {

  render() {
    const selectCounty = this.props.actions.selectCounty;

    const title = (
      <CardMenu showLocations={true} title={
        <span>
          {this.props.selectedCounty.name}
          <span className="hidden-sm-down"> County </span> Facility Locations
        </span>
      }/>
    );

    const legend = (
      <div className="legend hidden-sm-down">
        <svg width={10} height={10}>
          <circle r={5} cx={5} cy={5} fill="#c85a5a"></circle>
        </svg>
        <span>Treatment</span>
        <svg width={10} height={10}>
          <circle r={5} cx={5} cy={5} fill="#64acbe"></circle>
        </svg>
        <span>Providers</span>
      </div>
    );

    return (
      <Card className="CountyCard" title={title} extra={legend} noHovering={true} loading={this.props.loading}>
        <Row gutter={35}>
          <Col xs={24} md={6} xl={5}>

            <div className="hidden-md-down">
              <h2>Distribution of Treatment Facilities</h2>
              <StateMap
                stateFips={this.props.selectedState.fips}
                titleX="Number of Treatment Facilities"
                dimX="fac"
                dict={this.props.dict}
                data={this.props.data}
                useHeatScale={true}
                showCities={true}
                onClick={(stateId, countyId) => selectCounty(countyId)}/>
            </div>

            <p>Treatment for Opioid dependence is of great importance given the increasing rate of addiction, and
              understanding the accessibility of that treatment is critical.
            </p>

            <p className="lead">
              This map displays points for opioid providers and treatment facilities.
            </p>

            <p>The map above shows the distribution of opioid treatment facilities in the state - the darker the blue
              the higher the number of facilities. A county selected from the map will display county treatment
              facilities and provider detail to the left.
            </p>

          </Col>
          <Col xs={24} md={18} xl={19}>
            <MapboxLight countyFips={this.props.selectedCounty.fips} features={this.props.providerData}/>
          </Col>
        </Row>
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    loading: store.counties.loading,
    data: store.counties.data,
    dict: store.counties.dict,
    selectedState: store.states.selected,
    selectedCounty: store.counties.selected,
    providerData: store.providers.data
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(mapActions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(CountyCard);



// WEBPACK FOOTER //
// ./src/containers/CountyCard.js